import { Link } from 'react-router-dom';
import LocationBadge from '../components/Common/LocationBadge';
import Page from '../layout/components/Page';

const ServiceProviderPage = () => {
  const renderChildern = (
    <Link to='/service-providers' className='btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder'>
      <i className='bi bi-chevron-left'></i> Go Back
    </Link>
  );
  return (
    <Page title='Service Providers' icon='bi-people' toolbarChildren={renderChildern}>
      <div className='card'>
        <div className='card-body'>
          <div className='mx-auto mw-600px'>
            <div className='d-flex align-items-center mb-5'>
              <div className='d-flex align-items-center flex-grow-1'>
                <div className='symbol symbol-45px me-5'>
                  <img src='https://media.istockphoto.com/photos/portrait-of-a-successful-african-american-business-woman-outdoors-picture-id1129386304' alt='Lawyer' />
                </div>

                <div className='d-flex flex-column'>
                  <Link to='' className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                    DIYlaw Law Firm
                  </Link>

                  <div className='d-flex'>
                    <LocationBadge location='Lagos, Nigeria' />

                    <span className='mx-3 text-muted fw-bold text-muted d-block fs-7'>
                      <i className='bi bi-people'></i> Lawyer
                    </span>
                  </div>
                </div>
              </div>

              <div className='my-0'>
                <div className='rounded min-w-125px py-3 px-4 me-6'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-3 fw-bolder'>$45</div>
                  </div>
                  <div className='fw-bold fs-6 text-gray-400'>per hour</div>
                </div>
              </div>
            </div>
            <h3 className='card-title align-items-start flex-column'>
              <span className='text-muted fw-bold fs-7'>Address</span>
            </h3>
            <span className='text-justify text-gray-800 fw-normal'>3rd Floor 207 Regent Street, London, Greater London, United Kingdom, W1B 3HH.</span>
            <h3 className='card-title align-items-start flex-column mt-8'>
              <span className='text-muted fw-bold fs-7'>About us</span>
            </h3>
            <span className='text-justify text-gray-800 fw-normal pb-10'>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised
              in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </span>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default ServiceProviderPage;
